import { createSelector } from "reselect";

const selectSearch = (state) => state.search;

export const selectSearchInputValue = createSelector(
  [selectSearch],
  (search) => search.value
);
